import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileTypeId, FileTypes } from '@sb-shared/globals/file-types';
import { FileService } from '@sb-shared/services/file.service';
import { Ng1PrinceService } from '../../../ng1-services/ng1-prince.service';

@Component({
  selector: 'sb-export-button',
  templateUrl: './export-button.component.html',
  standalone: false
})
export class ExportButtonComponent {

  @Input() tableHeaders: string[];
  @Input() data: any[][];
  @Input() docTitle: string;
  @Input() subtitle: string;
  @Input() description: string;
  @Input() showDate: boolean;
  @Input() hideDate: boolean;
  @Input() showOrgInfo: boolean;
  @Input() showUserInfo: boolean;
  @Input() boldFirstColumn: boolean;
  @Input() isLandscape: boolean;
  @Input() info: any[];
  @Input() appendText: string;
  @Input() isDisabled: boolean;
  @Input() customLabel: string;

  isLoading = false;

  // CSV + PDF, matching the legacy sb-export-button (fileTypeEnum had both
  // marked isExportable: true). PDF generation is delegated to the existing
  // Ng1PrinceService → DataTableService → PdfService server-side flow.
  readonly fileTypes = FileTypes;

  constructor(
    private fileService: FileService,
    private translate: TranslateService,
    private prince: Ng1PrinceService
  ) {}

  get hasData(): boolean {
    return this.data?.length > 0;
  }

  saveFile(fileTypeId: number): void {
    const title = this.translate.instant(this.docTitle) || this.docTitle;
    const dateStr = (this.showDate && !this.hideDate)
      ? ' ' + new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      : '';
    const fileName = title + dateStr;

    const clonedData = JSON.parse(JSON.stringify(this.data || []));
    const contentData = this.tableHeaders
      ? [[...this.tableHeaders], ...clonedData]
      : clonedData;

    if (fileTypeId === FileTypeId.PDF) {
      this.isLoading = true;
      const headings = [title];
      if (this.subtitle) {
        headings.push(this.subtitle);
      }
      const pdfContent: any = {
        data: contentData,
        headings,
        description: this.description,
        info: this.info,
        showOrgInfo: this.showOrgInfo,
        showUserInfo: this.showUserInfo,
        boldFirstColumn: this.boldFirstColumn,
        isLandScape: this.isLandscape
      };
      const deferred = {
        resolve: () => { this.isLoading = false; },
        reject: () => { this.isLoading = false; }
      };
      this.prince.exportDataPdf(pdfContent, fileName, deferred);
      return;
    }

    this.fileService.saveFile(contentData, fileTypeId, fileName);
  }
}
